export const navItems = [
  {
    id: 1,
    title: "Nosotros", path: '/aboutUs', cName: "nav-item"
  },
  {
    id: 2,
    title: "Productos", path: '/#products', cName: "nav-item"
  },
  /*  {
     id:3,
     title: "Servicios",path: '/services', cName: "nav-item"
   }, */
  {
    id: 3,
    title: "Soporte", path: '/support', cName: "nav-item"
  },
  {
    id: 5,
    title: "Blog", path: '/blog', cName: "nav-item"
  }
];

export const nosotros = [
  {
    id: 1,
    title: "Acerca de T&T",
    path: "/aboutUs",
    cName: "submenu-item",
  },
  /* {
    id: 2,
    title: "Casos de exito",
    path: "/successStories",
    cName: "submenu-item",
  }, */
  /*  {
     id: 3,
     title: "Contacto",
     path: "/contact",
     cName: "submenu-item",
   } */
];


export const productos = [
  {
    id: 1,
    title: "T&T ERP",
    path: "/ttErp",
    cName: "submenu-item"
  },
  {
    id: 2,
    title: "T&T Nómina",
    path: "/ttNomina",
    cName: "submenu-item",
  },
  {
    id: 3,
    title: "T&T CFDI",
    path: "/ttCFDI",
    cName: "submenu-item",
  }
]


/* export const servicios = [
  {
    id:1,
    title: "Consultoria",
    path: '/services#consultancy', cName: "submenu-item"
  },
  {
    id:2,
    title: "Diseño Web",
    path: '/services#webDesign', cName: "submenu-item"
  },
  {
    id:3,
    title: "Desarrollo de aplicaciones",
    path: '/services#appDevelopment', cName: "submenu-item"
  },
  {
    id:4,
    title: "Hosting",
    path: '/services#hosting', cName: "submenu-item"
  },
  {
    id:5,
    title: "Marketing Digital",
    path: '/marketing', cName: "submenu-item"
  }
] */


export const soporte = [

  {
    id: 2,
    title: "Asistente en linea",
    path: '/onlineAssistant',
    cName: "submenu-item"
  }

]